import React from 'react';

type DetailRowProps = {
  label: string;
  value?: React.ReactNode;
};

/**
 * A read-only label / value row.
 *
 * Promoted here from form-management, which introduced it, now that
 * quotation-management uses it too. The old path re-exports this one so
 * form-management's imports are untouched — a second copy would be the real
 * problem, not the cross-module import.
 *
 * `value` is a ReactNode rather than a string so a badge can be passed in.
 */
export const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => {
  const isEmpty = value === undefined || value === null || value === '';

  return (
    <div className="row mb-7">
      <label className="col-lg-4 fw-bold text-muted">{label}</label>
      <div className="col-lg-8">
        <span className="fw-bolder fs-6 text-gray-800">
          {isEmpty ? '—' : value}
        </span>
      </div>
    </div>
  );
};

/** Format a boolean submission field as a human label. */
export const yesNo = (value: boolean): string => (value ? 'Ja' : 'Nee');
